export const browserLanguage = (navigator.language || navigator.userLanguage || "").toLowerCase()
